import { Serializable } from '../../../core/models/serializable';
import { CvBoxAccessTokenStatus } from './cv-box-access-token-status.enum';

export class CvBoxAccessTokenFilterModel
  implements Serializable<CvBoxAccessTokenFilterModel>
{
  fromObject(object: any): CvBoxAccessTokenFilterModel {
    throw new Error('Method not implemented.');
  }
  toObject() {
    return {
      StatusIds: this.statusIds,
      Customer: this.customer,
    };
  }

  public statusIds: CvBoxAccessTokenStatus[];
  public customer: string;
}
